/**
 * Tickets Page
 *
 * Displays all tickets using UniversalTable component
 * Route: /apps/tickets/all
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { UniversalTable } from '@/components/features/udc/UniversalTable';

export const TicketsPage: React.FC = () => {
  const navigate = useNavigate();

  const handleRowClick = (record: any) => {
    // Navigate to ticket detail page when row is clicked
    navigate(`/apps/tickets/${record.id}`);
  };

  return (
    <UniversalTable
      collection="tickets"
      title="All tickets"
      searchPlaceholder="Search tickets..."
      onRowClick={handleRowClick}
      customRenderers={{
        // Custom renderer for ticket title (make it a link)
        title: (value, record) => (
          <span style={{ fontWeight: 500, color: 'var(--primary-color)' }}>
            {value}
          </span>
        ),
      }}
    />
  );
};
